import * as Actions from '../actions';

// Feature: 001-org-multi-tenancy - Organizations Redux Reducer (T030)

const initialState = {
	list: [],
	organization: null,
	selected: null,
	users: [],
	myOrganization: null,
	searchText: '',
	loading: false,
	error: null,
	organizationModeEnabled: false
};

const organizationReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.SET_ORGANIZATIONS_LIST: {
			return {
				...state,
				list: action.payload,
				error: null
			};
		}
		case Actions.SET_ORGANIZATION: {
			return {
				...state,
				organization: action.payload,
				error: null
			};
		}
		case Actions.SET_SELECTED_ORGANIZATION: {
			return {
				...state,
				selected: action.payload
			};
		}
		case Actions.SET_ORGANIZATION_USERS: {
			return {
				...state,
				users: action.payload,
				error: null
			};
		}
		case Actions.SET_MY_ORGANIZATION: {
			return {
				...state,
				myOrganization: action.payload,
				error: null
			};
		}
		case Actions.SET_ORGANIZATION_ERROR: {
			return {
				...state,
				error: action.payload
			};
		}
		case Actions.SET_ORGANIZATION_LOADING: {
			return {
				...state,
				loading: action.payload
			};
		}
		case Actions.SET_ORGANIZATIONS_SEARCH_TEXT: {
			return {
				...state,
				searchText: action.searchText
			};
		}
		case Actions.SET_ORGANIZATION_MODE_ENABLED: {
			return {
				...state,
				organizationModeEnabled: action.payload
			};
		}
		case Actions.CLEAR_ORGANIZATION: {
			return {
				...state,
				organization: null,
				users: [],
				error: null
			};
		}
		case Actions.CLEAR_ORGANIZATION_ERROR: {
			return {
				...state,
				error: null
			};
		}
		case Actions.CLEAR_ORGANIZATIONS_REDUCER: {
			return initialState;
		}
		default: {
			return state;
		}
	}
};

export default organizationReducer;
